export function Show({show, children}) {
  return (
    show ? children : <></>
  );
}